(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const goodwillPopupSelector = '[data-lumibaby-goodwill-popup]';
  const goodwillPopupStorageKey = 'lumibaby-goodwill-popup-seen';

  function showGoodwillPopup() {
    const popup = document.querySelector(goodwillPopupSelector);

    if (!popup || popup.classList.contains('is-visible')) return;
    if (sessionStorage.getItem(goodwillPopupStorageKey)) return;

    popup.classList.add('is-visible');
    sessionStorage.setItem(goodwillPopupStorageKey, 'true');
  }

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-lumibaby-goodwill-close]');

    if (!closeButton) return;

    closeButton.closest(goodwillPopupSelector)?.classList.remove('is-visible');
  });

  new MutationObserver(showGoodwillPopup).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  showGoodwillPopup();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lb-newsletter-dialog"] && !Shopify.designMode) return;
  try {
    class LumiBabyNewsletterDialog extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }
    initialize() {
      if (this.initialized) return;
      this.dialog = this.querySelector('dialog');
      if (typeof this.dialog?.showModal !== 'function') return;
      this.initialized = true;
      this.storageKey = 'lb-newsletter-dialog-v2-seen';
      this.querySelectorAll('[data-newsletter-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (this.returnFocus instanceof HTMLElement && this.returnFocus.isConnected) this.returnFocus.focus({ preventScroll: true });
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')].filter((control) => control.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
      const result = this.querySelector('[data-newsletter-state]')?.dataset.newsletterState;
      if (location.hash === '#lb-newsletter-form' && (result === 'success' || result === 'error')) {
        this.open();
        return;
      }
      if (window.Shopify?.designMode) return;
      try { if (sessionStorage.getItem(this.storageKey)) return; } catch { return; }
      this.timer = setTimeout(() => this.openWhenReady(), 30000);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
    openWhenReady() {
      if (!this.isConnected) return;
      if (document.hidden || document.querySelector('dialog[open], header-drawer details[open]') || document.activeElement?.matches('input, textarea, select')) {
        this.timer = setTimeout(() => this.openWhenReady(), 5000);
        return;
      }
      this.open();
    }
    open() {
      if (this.dialog.open) return;
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      try { sessionStorage.setItem(this.storageKey, '1'); } catch {}
    }
  }
  if (!customElements.get('lb-newsletter-dialog')) customElements.define('lb-newsletter-dialog', LumiBabyNewsletterDialog);
  } catch(e) { console.error(e); }
})();

})();
